import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import useChatStore from 'stores/chat';
import { useRouter } from 'next/router';
import {
  DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT,
  DATA_CY_NAME_MESSAGE_HEADER_REQUESTS,
} from './__tests__/constant';
import { PopoverHeaderLoading } from './styled';

interface MessageHeaderProps {
  unreadRequest: number;
}

function MessageHeader({ unreadRequest = 0 }: MessageHeaderProps) {
  const router = useRouter();
  const isLoading = useChatStore((store) => store.rooms.default.isLoading);

  const onClickRequest = () => {
    router.push('/chat?type=request');
  };

  if (isLoading) {
    return (
      <PopoverHeaderLoading>
        <div />
        <div />
      </PopoverHeaderLoading>
    );
  }

  return (
    <Flex
      padding="16px 20px"
      justify="space-between"
      data-cy={DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT}
    >
      <Text family="bold" weight="400">
        Messages
      </Text>
      <Text
        color={color.primary}
        as="span"
        onClick={onClickRequest}
        style={{ cursor: 'pointer' }}
        data-cy={DATA_CY_NAME_MESSAGE_HEADER_REQUESTS}
      >
        Requests {unreadRequest >= 1 && `(${unreadRequest})`}
      </Text>
    </Flex>
  );
}

export default MessageHeader;
